module.exports = __webpack_public_path__ + "img/5-3.37fe0c64.svg";